import { Component, OnInit } from '@angular/core';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { ChatService } from '../../services/chat.service';
import { AlertService } from '../../providers/alert.service';
import { App } from 'ionic-angular/components/app/app';
import { SigninPage } from '../signin/signin';
import { ImService } from './im.service';
import * as $ from 'jquery';
import { checkNoChangesNode } from '@angular/core/src/view/view';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import { ChatDetailsPage } from './chat-details';


@Component({
    selector: 'message-group',
    templateUrl: './message-group.html',
    providers: [
        ImService
    ]
})
export class MessageGroupPage implements OnInit {
    subUser = [];   //所有下级
    focus;
    blur;
    inputval;  // 使用ngModel绑定输入框的值
    upUser;    // 上级用户名
    type = -1;
    linkmanList = []; //联系人列表
    selectLowerList = [];  // 已选中联系人
    userNum: number = 0;
    Groupsearch = '';
    subordinates;
    constructor(
        private viewCtrl: ViewController,
        private chat: ChatService,
        private imservice: ImService,
        private navCtrl: NavController,
        private alert: AlertService
    ) {
        // 获取上级用户名
        this.upUser = this.imservice.getParentUserName();
    }

    ngOnInit(): void {
        this.getUpUserOrSubUsers();
    }

    // 搜索功能
    getUpUserOrSubUsers() {
        this.chat.getUpUserOrSubUsers({ searchUserName: this.inputval }).then(s => {
            this.subUser = [];
            if (s && s.Value.length > 0) {
                this.linkmanList = s.Value;
                this.subUser = this.linkmanList;
                this.selectLowerList.forEach(element => {
                    s.Value.forEach(e => {
                        if (element.UserName == e.UserName) {
                            e.checked = true;
                        }
                    });
                });
            }
        });
    }
    /**
     *
     * 群发 添加联系人
     */
    changeSub(event) {
        this.linkmanList.find(x => x.UserName == event.target.id).checked = event.target.checked;
        this.subUser.find(x => x.UserName == event.target.id).checked = event.target.checked;
        this.selectLowerList = this.linkmanList.filter(x => x.checked == true);
        if (this.linkmanList.length == this.selectLowerList.length) {
            this.type = 1
        } else if (this.linkmanList.filter(x => x.Level == 2).length == this.selectLowerList.length
            && this.selectLowerList.filter(x => x.Level == 1).length == 0) {
            this.type = 2
        } else {
            this.type = -1
        }
        this.userNum = this.selectLowerList.length;
    }
    allChecked(val) {
        this.type == val ? this.type = -1 : this.type = val;
        for (let i = 0; i < this.subUser.length; i++) {
            this.subUser[i].checked = (this.type == val ? true : false);
            this.linkmanList.find(x => x.UserName == this.subUser[i].UserName).checked = (this.type == val ? true : false);
            if (val == 2 && this.subUser[i].Level == 1) {
                this.subUser[i].checked = false;
                this.linkmanList.find(x => x.UserName == this.subUser[i].UserName).checked = false;
            }
        }
        this.selectLowerList = this.linkmanList.filter(x => x.checked == true);
        this.userNum = this.selectLowerList.length;

    }

    // 搜索框失去焦点样式
    onBlur() {
        const searchinput = document.getElementById('search-input');
        const searchicon = document.getElementById('search-icon');
        if (this.inputval && this.inputval.length > 0) { }
        else {
            searchinput.classList.remove("onfocus-input");
            searchicon.classList.remove("onfocus-icon");
            searchinput.setAttribute('placeholder', '');
        }
    }
    // 搜索框获得焦点样式
    onFocus() {
        const searchinput = document.getElementById('search-input');
        const searchicon = document.getElementById('search-icon');
        searchinput.classList.add("onfocus-input");
        searchicon.classList.add("onfocus-icon");
        searchinput.setAttribute('placeholder', '搜索');
    }
    // 后退
    dismiss() {
        this.viewCtrl.dismiss();
    }
    // 下一步
    next() {
        if (this.userNum == 0) {
            this.alert.showAlert('收信人不能为空，请重新选择!');
            return;
        } else {
            const param = {
                selectUser: this.selectLowerList,
                userNum: this.userNum,
            }
            this.navCtrl.push(ChatDetailsPage, {
                params: param
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/im/message-group.ts